module.exports = __webpack_public_path__ + "static/media/campus_9.f25f0e7a.png";